import { useTranslation } from 'react-i18next';
import CeldaSocioAdmin from './CeldaSocioAdmin';


export default function TablaSociosAdmin({ socios, setSocios }) {

  const { t } = useTranslation();

  return (
    <div
      className="table-responsive"
      style={{ maxHeight: '450px', overflowY: 'scroll' }}
    >
      <table className="table">
        <thead>
          <tr>
            <th className="col-sm px-sm-2">{t('NAME')}</th>
            <th className="col-sm px-sm-2">{t('TYPE')}</th>
            <th className="col-sm px-sm-2">{t('CABIN_TYPE')}</th>
            <th className="col-sm px-sm-2">{t('MEMBERSHIP')}</th>
            <th className="col-sm px-sm-2">{t('MEMBER_SINCE')}</th>
            <th className="col-sm px-sm-2">{t('TIMES_DELINQUENT')}</th>
            <th className="col-sm px-sm-2">{t('DELINQUENT')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {socios.map((socio) => (
            <CeldaSocioAdmin
              key={socio.id}
              socio={socio}
              setSocios={setSocios}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
